const BaseComponent = require('base/infoline');

module.exports = class investmentHeader extends BaseComponent { };
